__turbopack_context__.v({
  "back-button": "F23zsW_back-button",
  "header": "F23zsW_header",
  "placeholder": "F23zsW_placeholder",
  "progress-bar": "F23zsW_progress-bar",
  "progress-bar-fill": "F23zsW_progress-bar-fill",
  "text": "F23zsW_text",
});
